module.exports = __webpack_public_path__ + "img/clipboard-checkazq.0fb235e7.png";